import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { environment } from '../../../environments/environment';

/** Use em requisições específicas para NÃO enviar Authorization */
export const NO_AUTH = new HttpContextToken<boolean>(() => false);

// Chave usada pelo AuthService para armazenar o token no sessionStorage
const SESSION_TOKEN_KEY = '@acelerador_avatax:access_token';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // 1) Permite "opt-out" por request
  if (req.context.get(NO_AUTH)) {
    return next(req);
  }

  // 2) Evita duplicar se já veio Authorization explícito
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  // 3) Anexar apenas para a API desta aplicação
  const apiBase =
    (environment as any)?.api?.baseUrl ||
    (environment as any)?.backendUrl ||
    '';

  if (apiBase && !req.url.startsWith(apiBase)) {
    return next(req);
  }

  // 4) Obter token do sessionStorage (definido pelo AuthService após login)
  // envToken só é usado em dev se NÃO houver token de sessão (fallback de desenvolvimento)
  const storedToken = sessionStorage.getItem(SESSION_TOKEN_KEY) || undefined;
  const envToken = !storedToken && isDevMode() ? ((environment as any)?.token as string | undefined) : undefined;

  const token = storedToken || envToken;

  if (!token) {
    return next(req);
  }

  // 5) Clona com Authorization
  const authReq = req.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  });

  return next(authReq);
};
